import React, { useState } from 'react';
import { Form, Input, Button } from 'antd';
import { Navigate } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import './ForgotPassword.css';
import config from "../../config.js";

const ForgotPassword = () => {
    const [submitted, setSubmitted] = useState(false);
    const [otpSent, setOtpSent] = useState(false);
    const [userID, setUserID] = useState('');
    const [otp, setOtp] = useState('');
    const [form] = Form.useForm();
    const navigate = useNavigate();

    const onFinish = async (values) => {
        if (!otpSent) {
            const { userID } = values;
            localStorage.setItem('userID',userID);
            try {
                const response = await fetch(`${config.BASE_URL_IP}/wob/forgot-password`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ userID })
                });

                const data = await response.json();

                if (response.ok) {
                    setOtpSent(true);
                    setUserID(userID);
                    setOtp(data.otp); // Store the OTP in state for verification
                    window.alert('An OTP has been sent to your email address.');
                } else {
                    window.alert(data.message || 'An error occurred while sending the email.');
                }
            } catch (err) {
                console.error('Failed:', err.message);
                window.alert('An error occurred: ' + err.message);
            }
        } else {
            const { otpInput } = values;
            if (otpInput === otp) {
                setSubmitted(true);
                window.alert('OTP verified successfully.');
            } else {
                window.alert('Invalid OTP. Please try again.');
            }
        }
    };

    const onFinishFailed = (errorInfo) => {
        console.log('Failed:', errorInfo);
    };

    if (submitted) {
        return navigate(`/workorder/wof/login/reset-password`);
    }

    return (
        <div className="forgot-password-page">
            <div className="forgot-password-box">
                <Form
                    form={form}
                    name="forgot-password-form"
                    initialValues={{ remember: true }}
                    onFinish={onFinish}
                    onFinishFailed={onFinishFailed}
                >
                    <p className="form-title">Forgot Password</p>
                    {!otpSent ? (
                        <>
                            <p>Enter your User ID to reset your password</p>
                            <Form.Item
                                name="userID"
                                rules={[{ required: true, message: 'Please input your User ID!' }]}
                            >
                                <Input placeholder="User ID" />
                            </Form.Item>
                        </>
                    ) : (
                        <>
                            <p>Enter the OTP sent to your email</p>
                            <Form.Item
                                name="otpInput"
                                rules={[{ required: true, message: 'Please input the OTP!' }]}
                            >
                                <Input placeholder="OTP" />
                            </Form.Item>
                        </>
                    )}

                    <Form.Item>
                        <Button type="primary" htmlType="submit">
                            Submit
                        </Button>
                    </Form.Item>
                </Form>
            </div>
        </div>
    );
};

export default ForgotPassword;
